export function toLocalIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseIsoDateUtc(isoDate: string): Date {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(Date.UTC(year ?? 1970, (month ?? 1) - 1, day ?? 1));
}

export function toUtcIsoDate(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDate(isoDate: string): string {
  return new Intl.DateTimeFormat('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(parseIsoDateUtc(isoDate));
}

export function weekdayLabel(isoDate: string): string {
  return new Intl.DateTimeFormat('de-DE', {
    weekday: 'long',
    timeZone: 'UTC',
  }).format(parseIsoDateUtc(isoDate));
}

export function formatMonthLabel(month: string): string {
  const [year, monthNumber] = month.split('-').map(Number);
  const date = new Date(Date.UTC(year ?? 1970, (monthNumber ?? 1) - 1, 1));

  return new Intl.DateTimeFormat('de-DE', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}

export function getWednesdaysForMonth(month: string): string[] {
  const [year, monthNumber] = month.split('-').map(Number);
  const dates: string[] = [];
  const current = new Date(Date.UTC(year ?? 1970, (monthNumber ?? 1) - 1, 1));

  while (current.getUTCMonth() === (monthNumber ?? 1) - 1) {
    if (current.getUTCDay() === 3) {
      dates.push(toUtcIsoDate(current));
    }

    current.setUTCDate(current.getUTCDate() + 1);
  }

  return dates;
}

export function getFirstWednesdayForMonth(month: string): string {
  return getWednesdaysForMonth(month)[0] ?? `${month}-01`;
}

export function shiftIsoMonth(month: string, monthDelta: number): string {
  const [year, monthNumber] = month.split('-').map(Number);
  const date = new Date(
    Date.UTC(year ?? 1970, (monthNumber ?? 1) - 1 + monthDelta, 1),
  );
  const shiftedYear = date.getUTCFullYear();
  const shiftedMonth = String(date.getUTCMonth() + 1).padStart(2, '0');

  return `${shiftedYear}-${shiftedMonth}`;
}

export function getUpcomingWednesday(referenceDate: Date): string {
  const nextWednesday = new Date(referenceDate);
  const dayDelta = (3 - nextWednesday.getDay() + 7) % 7;
  nextWednesday.setDate(nextWednesday.getDate() + dayDelta);
  return toLocalIsoDate(nextWednesday);
}

export function previousWednesday(isoDate: string): string {
  const date = parseIsoDateUtc(isoDate);
  const dayDelta = (date.getUTCDay() - 3 + 7) % 7 || 7;
  date.setUTCDate(date.getUTCDate() - dayDelta);
  return toUtcIsoDate(date);
}

export function nextWednesday(isoDate: string): string {
  const date = parseIsoDateUtc(isoDate);
  const dayDelta = (3 - date.getUTCDay() + 7) % 7 || 7;
  date.setUTCDate(date.getUTCDate() + dayDelta);
  return toUtcIsoDate(date);
}
